<template>
<div class="container">
    <div class="row">
        <Button v-if="$store.state.user.userAdm || USER_TYPE_MIXIN.isBackOffice" class="mb-3" @click="backStep" size="small" type="outline" color="grey">
            <ArrowDropdown :rotate="90" /> Voltar
        </Button>
        <RegisterHeader />
        <BoxRegister>
            <div class="col-12 mt-4 mb-5">
                <h4 class="c-ndarkfour bold">
                    Grupo econômico
                </h4>
            </div>
            <div class="col-12 mb-4 box-groups">
                <BusinessGroup v-if="$store.state.group.groups.length" :tableData="$store.state.group.groups" @groupDeleted="getGroups"/>
                <EmptyRegisterGroup v-else-if="!$store.state.group.groups.length" />
            </div>
        </BoxRegister>
    </div>
    <ConfirmRegisterChange :dialogVisible="dialogVisible" @closeModal="dialogVisible = false"/>
</div>
</template>

<script>
//import CompanyTypeStatus from '@/components/status/CompanyTypeStatus'
import ArrowDropdown from '@/components/icons/ArrowDropdown'
import BusinessGroup from '@/components/tables/BusinessGroup'
import BoxRegister from '@/components/box/BoxRegister'
import getEconomicGroupsByCnpjId from '@/api/getEconomicGroupsByCnpjId'
import RegisterHeader from '@/components/register/RegisterHeader'
import ConfirmRegisterChange from '@/components/modals/ConfirmRegisterChange'
import EmptyRegisterGroup from '@/components/emptyOrNotFound/EmptyRegisterGroup'

export default {
    components: {
        //CompanyTypeStatus,
        ArrowDropdown,
        BusinessGroup,
        BoxRegister,
        RegisterHeader,
        ConfirmRegisterChange,
        EmptyRegisterGroup,
    },
    data() {
        return {
            activeTab: '',
            dialogVisible: false,
            userToDelete: {
                id: null
            },
            dialogVisibleUserDelete: false,
        }
    },
    computed: {
        partnersList() {
            return this.$store.state.register.partners.filter(partners => partners.associateType != 'Procurador' && partners.name)
        },
        procuratorList() {
            return this.$store.state.register.partners.filter(partners => partners.associateType == 'Procurador' && partners.name)
        },
        allRegistersStatusIsComplete() {
            return this.$store.state.register.partners.every(partners => partners.registerComplete == 1)
        }
    },
    methods: {
        async getGroups() {
            await getEconomicGroupsByCnpjId(this.$route.params.idCNPJ)
        },
        backStep() {
            if (this.$store.state.user.userAdm || this.USER_TYPE_MIXIN.isBackOffice) {
                const regex = /provider|buyer|sponsor/g
                this.$router.push(`/company/${this.$route.path.match(regex)[0]|| 'provider'}`)
            } else {
                this.$router.push(`/company`)
            }
        },
        newUser() {
            this.$router.push(`/user/company/${this.$route.params.idCNPJ}/new`)
        },
    },
    async created() {
        await this.getGroups()
        this.$store.commit('register/setFormIsChanged', false)
    }
}
</script>

<style lang="scss" scoped>
.box-groups {
    height: 375px;
    overflow: scroll;
}
</style>
